import { createActions } from 'redux-actions';

export const {
  //GET ALL VEHICLES
  getAllVehicles,
  getAllVehiclesSuccess,
  getAllVehiclesError,
  //GET FILTER VEHICLES
  getFilterVehicles,
  getFilterVehiclesSuccess,
  getFilterVehiclesError,

  // GET VEHICLE BY STATUS
  getActualVehicles,
  getActualVehiclesSuccess,
  getActualVehiclesError,

  getArchiveVehicles,
  getArchiveVehiclesSuccess,
  getArchiveVehiclesError,
  // FILTER REQUESTS

  //GET VEHICLE
  getVehicle,
  getVehicleSuccess,
  getVehicleError,
  //POST REQUEST

  //PUT REQUEST

  //DELETE REQUEST

  // FILTER VEHICLES
  filterVehicles,

  applyFilters,
  applyFiltersSuccess,
  applyFiltersError,

  setFiltersCount,
  resetFiltersVehicles,
  filterVehiclesSuccess,
  filterVehiclesError,

  applySearch,
  applySearchSuccess,
  applySearchError,
} = createActions(
  'GET_ALL_VEHICLES',
  'GET_ALL_VEHICLES_SUCCESS',
  'GET_ALL_VEHICLES_ERROR',

  'GET_FILTER_VEHICLES',
  'GET_FILTER_VEHICLES_SUCCESS',
  'GET_FILTER_VEHICLES_ERROR',

  'GET_ACTUAL_VEHICLES',
  'GET_ACTUAL_VEHICLES_SUCCESS',
  'GET_ACTUAL_VEHICLES_ERROR',

  'GET_ARCHIVE_VEHICLES',
  'GET_ARCHIVE_VEHICLES_SUCCESS',
  'GET_ARCHIVE_VEHICLES_ERROR',

  'GET_VEHICLE',
  'GET_VEHICLE_SUCCESS',
  'GET_VEHICLE_ERROR',

  'FILTER_VEHICLES',

  'APPLY_FILTERS',
  'APPLY_FILTERS_SUCCESS',
  'APPLY_FILTERS_ERROR',

  'SET_FILTERS_COUNT',
  'RESET_FILTERS_VEHICLES',
  'FILTER_VEHICLES_SUCCESS',
  'FILTER_VEHICLES_ERROR',

  'APPLY_SEARCH',
  'APPLY_SEARCH_SUCCESS',
  'APPLY_SEARCH_ERROR'
);
